import './ServerPage.css';
import {Helmet} from "react-helmet";

import Background from "@/commons/pages/borders/background/Background";
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";

import FileHandler from "./objects/file/FileHandler";
import ServerObj from "./objects/Main/ServerObj";
import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import Redirects from "@/commons/utils/Redirects";


const ServerPage = () => {
    let {currentServer} = useParams();
    const [servers, setServers] = useState<ServerObj[] | undefined>(undefined);

    async function FileManager() {
        setServers([]);
        let files = await FileHandler.getFileList()

        for (let i = 0; i < files.length; i++) {
            let fileName = files[i]
            let fileData = await FileHandler.loadFile(fileName);
            let obj = new ServerObj(fileData.title, fileData.description, fileData.preview, fileName)

            addServer(obj)
        }
    }

    function addServer(server: ServerObj): void {
        setServers((prevServers) =>
            prevServers ? [...prevServers, server] : [server]
        );
    }

    useEffect(() => {
        FileManager();
    }, []);

    return (
        <>
            <Background/>
            <div className={"serverPage__body"}>
                <Header/>
                <div className={"serverPage__modalitiesBox"}>
                    {currentServer ? (
                        (() => {
                            // Cerchiamo tra i server quello il cui `title` corrisponde a `currentServer` (ignorando maiuscole/minuscole)
                            const foundServer = servers?.find(
                                (obj) => currentServer && obj.title.toLowerCase() === currentServer.toLowerCase()
                            );
                            // Se esiste, rendiamo la vista completa del server
                            // Altrimenti mostriamo la preview di tutta la lista
                            let title = foundServer ? "EBLCraft - " + foundServer.title : "EBLCraft";
                            let description = foundServer ? foundServer.preview ? foundServer.preview.description : "" : "";
                            description = description.replaceAll("<br>", "");
                            let keywords = "Minecraft, server Minecraft Italiano, EBLCraft, ErenBlaze, modalità Minecraft, server " + (foundServer ? foundServer.title : "EBLCraft")
                            return foundServer
                                ? <>
                                    <Helmet>
                                        <title>{title}</title>
                                        <meta name="description" content={description}/>
                                        <meta name="keywords" content={keywords} />
                                        <meta property="og:title" content={title}/>
                                        <meta property="og:description" content={description}/>
                                        <meta name="twitter:title" content={title}/>
                                        <meta name="twitter:description" content={description}/>
                                    </Helmet>
                                    <div className={"serverPage__fullPage"}>
                                        {foundServer.renderer()}
                                    </div>
                                </>
                                : servers?.map((obj) => obj.previewRender());
                        })()
                    ) : (
                        // Se `currentServer` non è impostato, mostriamo subito la preview di tutti i server
                        servers?.map((obj) => obj.previewRender())
                    )}
                </div>
                <Footer/>
            </div>
        </>
    );

}

export default ServerPage;